import React from 'react';
import Button from "./Button";
import { FieldArray, useField } from "formik";
import Callout from "../structure/Callout";
import { PdsIconPlus } from "@principal/design-system-icons-react";

var _ = require('lodash');

type AddListElementButtonProps = {
    otherElementProps?: any,
    idPrefix: string,
    buttonText: string,
    componentType: React.ComponentType<ListElementProps>,
    elementInitialValue: object,
    label?: string,
    required?: boolean,
    children?: React.ReactNode
}

export type ListElementProps = {
    idPrefix: string,
    index?: number,
    otherProps?: any,
    closeCallback?: Function,
    children?: React.ReactNode
}

const AddListElementButton = (props: AddListElementButtonProps) => {
    const idPrefix = props.idPrefix;
    const listId = _.camelCase(idPrefix);
    const [, meta, helpers] = useField(listId);
    if (meta.initialValue === undefined) {
        return null;
    }
    return (<div>
            <FieldArray name={listId} render={() => {
                if (!meta.value) {
                    return null;
                }
                return (
                    <>
                        {props.label && <div className="pds-u-margin-bottom-16">
                            <label className={props.required ? "is-required" : ""}>{props.label}</label>
                        </div>}
                        {meta.value.map((entry: any, index: number) => (
                            <Callout>
                                <props.componentType key={index} idPrefix={idPrefix} index={index}
                                                     closeCallback={() => {
                                                         meta.initialValue.splice(index, 1)
                                                         if (meta.value.length > meta.initialValue.length) {
                                                             meta.value.splice(index, 1)
                                                         }
                                                         helpers.setValue(meta.value)
                                                     }}
                                                     otherProps={props.otherElementProps}/>
                            </Callout>
                        ))}
                        <div className="pds-u-margin-bottom-16">
                            <Button buttonContent={<><PdsIconPlus slot="icon-left"/> <span>{props.buttonText}</span></>}
                                    buttonProps={{ size: "sm" }}
                                    onClick={() => {
                                        meta.initialValue.push(props.elementInitialValue)
                                        if (meta.value.length < meta.initialValue.length) {
                                            meta.value.push(props.elementInitialValue)
                                        }
                                        helpers.setValue(meta.value)
                                    }}/>
                        </div>
                    </>
                );
            }}/>
        </div>
    )
};

export function buildArrayIdFor(id: string, props: ListElementProps) {
    return props.idPrefix + "-" + id + "-" + props.index;
}

export function buildArrayNameFor(name: string, props: ListElementProps) {
    const namePrefix = _.camelCase(props.idPrefix);
    const indexPrefix = `${namePrefix}[${props.index}].`;
    return `${indexPrefix}${name}`;
}

export default AddListElementButton;